import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

import { aiAgentBoxBorderStroke } from "app/pages/sales-intelligence/modules/ai-agent/components";

import AIAgentCaption from "../AIAgentCaption/AIAgentCaption";

export const StyledAICaption = styled(AIAgentCaption)`
    margin: -8px 0 0 0;
    padding-left: 8px;
`;

export const StyledAgentPromptCard = styled(Stack)`
    ${aiAgentBoxBorderStroke};

    gap: 16px;
    padding: 12px;

    border-radius: 8px;
`;
